import React from 'react';
import ListFormHeaderContainer from "../Containers/FormHeaderListContainer"

const FormHeaderPages = () => {
    return (
        <div>
           <ListFormHeaderContainer/>
        </div>
    );
};

export default FormHeaderPages;